Ext.define('SA.view.CheckButton', {
    alias: 'widget.check-button',
    extend: 'Ext.Component',

    baseCls: 'sa-check-button',
    checked: false,

    initComponent() {
        this.callParent();

        this.setChecked(this.isChecked());
    },

    initEvents() {
        this.callParent();

        this.el.on('click', this.onClick, this);
    },

    isChecked() {
        return this.checked;
    },

    onClick(ev) {
        ev.stopPropagation();

        this.setChecked(!this.isChecked());

        this.fireEvent('click', this.isChecked());
    },

    setChecked(checked) {
        this.checked = checked;

        this.ifCls(checked, 'sa-check-button-checked');
    }
});